import { authenticateRequest } from '@api/authenticateRequest';

import type { components, operations } from '@type/model';
import type { OmitGroupIdInHeader } from '@type/util';

type updateAttendUserPath =
  operations['AdminGroupEventController_updateGroupEventMember']['parameters']['path'];
type updateAttendUserData = components['schemas']['AdminUpdateGroupEventMemberDto'];
type updateAttendUserHeaders =
  operations['AdminGroupEventController_updateGroupEventMember']['parameters']['header'];

interface updateAttendUserProps {
  path: updateAttendUserPath;
  data: updateAttendUserData;
  headers?: OmitGroupIdInHeader<updateAttendUserHeaders>;
}

type updateAttendUserResponse = unknown;

export async function updateAttendUser({
  path,
  data,
  headers,
}: updateAttendUserProps): Promise<updateAttendUserResponse | false> {
  const response = await authenticateRequest<updateAttendUserResponse>({
    method: 'patch',
    url: `/api/v1/admin/group-event/${path.groupEventId}/members/${path.groupEventMemberId}`,
    headers,
    data,
  });

  console.log('updateAttendUser', { response });
  return response;
}
